<template>
  <div>
    <validation-provider
      :name="$t(`commands.form.${config.name}.label`)"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <label class="d-block">
        {{ $t(`commands.form.${config.name}.label`) }}
      </label>
      <v-select
        v-model="model"
        :options="alarmLevelsOptions"
        label="description"
        :clearable="true"
        :reduce="(val) => val.id"
        input-id="alarm_type"
        :multiple="multiple"
        @input="$emit('input', model)"
      >
        <template #selected-option="option">
          <span
            :style="`display: inline-block; margin-right: 5px; width: 15px; height: 15px; background-color: ${option.color};`"></span>
          {{ option.level }} - {{ option.description }} {{ option.tenant ? `(${option.tenant.name})` : '' }}
        </template>
        <template v-slot:option="option">
          <span
            :style="`display: inline-block; margin-right: 5px; width: 15px; height: 15px; background-color: ${option.color};`"></span>
          {{ option.level }} - {{ option.description }} {{ option.tenant ? `(${option.tenant.name})` : '' }}
        </template>
      </v-select>
      <p v-if="config.hint" class="mb-0 small">{{ $t(config.hint) }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import vSelect from "vue-select";
import {ValidationProvider} from "vee-validate";
import store from "@/store";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
    config: Object,
    context: Object,
    nodeConfig: Object,
  },
  data() {
    return {
      model: null,
      options: [],
    };
  },
  created() {
    this.model = this.value || null;
  },
  mounted() {
    if (!this.alarmLevels.length) {
      store.dispatch("alarm_level/getAll");
    }
  },
  computed: {
    alarmLevels() {
      const alarmLevels = store.getters["alarm_level/getItems"];
      return alarmLevels.map(alarmLevel => ({...alarmLevel}));
    },
    alarmLevelsOptions() {
      if (this.options.length) return this.options;

      this.options = [...this.alarmLevels];

      return this.options;
    },
  },
};
</script>

<style></style>
